import React from 'react';

export default function ConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  type = "danger" // "danger", "warning", or "info"
}) {
  if (!isOpen) return null;

  // Set the color scheme based on the type
  const getColorScheme = () => {
    switch (type) {
      case "danger":
        return {
          headerBg: "bg-red-600",
          confirmBg: "bg-red-600",
          confirmHoverBg: "bg-red-700",
          confirmRing: "ring-red-500",
          icon: (
            <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          )
        };
      case "warning":
        return {
          headerBg: "bg-yellow-500",
          confirmBg: "bg-yellow-500",
          confirmHoverBg: "bg-yellow-600",
          confirmRing: "ring-yellow-400",
          icon: (
            <svg className="h-6 w-6 text-yellow-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          )
        };
      default: // info
        return {
          headerBg: "bg-blue-600",
          confirmBg: "bg-blue-600",
          confirmHoverBg: "bg-blue-700",
          confirmRing: "ring-blue-500",
          icon: (
            <svg className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          )
        };
    }
  };

  const colors = getColorScheme();

  return (
    <>
      {/* Modal backdrop */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity"
        onClick={onClose}
      />

      {/* Modal dialog */}
      <div className="fixed inset-0 z-50 overflow-y-auto">
        <div className="flex items-center justify-center min-h-screen p-4">
          <div
            className="bg-white rounded-lg shadow-xl max-w-md w-full mx-auto overflow-hidden"
            onClick={e => e.stopPropagation()}
          >
            {/* Modal header */}
            <div className={`${colors.headerBg} text-white px-4 py-3 flex items-center`}>
              <h3 className="text-lg font-medium">{title}</h3>
            </div>

            {/* Modal body */}
            <div className="p-6">
              <div className="flex items-start">
                <div className="flex-shrink-0">
                  {colors.icon}
                </div>
                <div className="ml-3">
                  <div className="text-sm text-gray-700">{message}</div>
                </div>
              </div>
            </div>

            {/* Modal footer */}
            <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
              <button
                type="button"
                className={`w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 ${colors.confirmBg} text-base font-medium text-white hover:${colors.confirmHoverBg} focus:outline-none focus:ring-2 focus:ring-offset-2 focus:${colors.confirmRing} sm:ml-3 sm:w-auto sm:text-sm`}
                onClick={onConfirm}
              >
                {confirmText}
              </button>
              <button
                type="button"
                className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                onClick={onClose}
              >
                {cancelText}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
